import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { useUserInfor } from "../../../../Context/User";
import { IDocumento } from "../../../../Interfaces/Geral/CasoDocumentos/CasoDocumentosInterface";
import { AtualizarDocumentoController } from "../../../../Controllers/Geral/CasoDocumentos/CasoDocumentosController";
import { ListarTipoDocumentoController } from "../../../../Controllers/Geral/GestaoDeCadastros/TipoDocumento/TipoDocumentoController";
import LazySelect from "../../Forms/LazySelect";
import { useForm } from "react-hook-form";

interface IAtualizarDocumentoFormData {
    DS_DOCUMENTO: string;
    ID_TIPO_DOCUMENTO: number;
}

interface ModalCadastrarPropsInterface {
    setShow: (show: boolean) => void;
    updateList: () => void;
    documentos: IDocumento;
}

export default function AtualizarDocumento(
    props: ModalCadastrarPropsInterface
) {
    const { Atendimento } = useAtendimentoPage();
    const userId = useUserInfor().UserInfor.ID_USUARIO;

    const { register, handleSubmit, setValue } = useForm();

    const partes = props.documentos.DS_DOCUMENTO?.split(".");
    const divNome = props.documentos.DS_DOCUMENTO?.split(
        ".",
        (partes?.length ?? 1) - 1
    );
    const divTipo = partes?.slice(-1);

    const handleAtualizarDocumentoFormSubmit = (
        formData: IAtualizarDocumentoFormData
    ) => {
        if (userId && Atendimento && formData.DS_DOCUMENTO) {
            AtualizarDocumentoController({
                ...props.documentos,
                DS_DOCUMENTO: formData.DS_DOCUMENTO + "." + divTipo,
                ID_TIPO_DOCUMENTO: formData.ID_TIPO_DOCUMENTO,
            }).then((res) => {
                props.setShow(false);
                props.updateList();
            });
        }
    };

    return (
        <>
            <h4>Atualização de documento</h4>
            <form
                className="d-flex flex-wrap form-group row"
                onSubmit={handleSubmit(handleAtualizarDocumentoFormSubmit)}
            >
                <div className="col-10 mt-3">
                    <label>Nome Documento </label>
                    <input
                        className="form-control"
                        name="DS_DOCUMENTO"
                        ref={register()}
                        placeholder="Descrição"
                        defaultValue={divNome}
                    />
                </div>
                <div className="col-2 mb-4 align-self-end p-0">
                    <span>{"." + divTipo}</span>
                </div>
                <div className="col-12 mt-3">
                    <LazySelect
                        label="Tipo do documento"
                        name="ID_TIPO_DOCUMENTO"
                        ref={register({
                            valueAsNumber: true,
                        })}
                        className="form-control"
                        controller={ListarTipoDocumentoController}
                        getDS={(p) => p.DS_TIPO_DOCUMENTO}
                        getKeyValue={(p) => p.ID_TIPO_DOCUMENTO}
                        defaultValue={props.documentos.ID_TIPO_DOCUMENTO}
                        setValue={setValue}
                    >
                        <option></option>
                    </LazySelect>
                </div>
                <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                    <button
                        type="submit"
                        className="btn btn-capys font-weight-bold btn-block mt-2"
                    >
                        Atualizar
                    </button>
                </div>
            </form>
        </>
    );
}
